module.exports = {"370181001":"明水街道","370181002":"双山街道","370181003":"枣园街道","370181004":"龙山街道","370181005":"埠村街道","370181006":"圣井街道","370181007":"普集街道","370181008":"绣惠街道","370181009":"相公庄街道","370181010":"文祖街道","370181011":"官庄街道","370181105":"垛庄镇","370181106":"水寨镇","370181110":"刁镇","370181111":"曹范镇","370181113":"白云湖镇","370181114":"高官寨镇","370181115":"宁家埠镇","370181122":"辛寨镇","370181123":"黄河镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370181.json
// module id = 1480
// module chunks = 0